// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a-snake-body {
    background-color: #386994;
    border: .25vmin solid black;
}

.b-snake-body {
    background-color: #f55733;
    border: .25vmin solid black;
}

.general-expand-food {
    background-color: #ffa000;
    border: .25vmin solid black;
    border-radius: 999em;
}

.mega-expand-food {
    background-color: #14a343;
    border: .25vmin solid black;
    border-radius: 999em;
}

.double-fast-food {
    background-color: #571bbf;
    border: .25vmin solid black;
    border-radius: 999em;
}

.food {
    background-color: #e60ecc;
    border: .25vmin solid black;
    border-radius: 999em;
}
`, "",{"version":3,"sources":["webpack://./src/style/role.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,oBAAoB;AACxB","sourcesContent":[".a-snake-body {\n    background-color: #386994;\n    border: .25vmin solid black;\n}\n\n.b-snake-body {\n    background-color: #f55733;\n    border: .25vmin solid black;\n}\n\n.general-expand-food {\n    background-color: #ffa000;\n    border: .25vmin solid black;\n    border-radius: 999em;\n}\n\n.mega-expand-food {\n    background-color: #14a343;\n    border: .25vmin solid black;\n    border-radius: 999em;\n}\n\n.double-fast-food {\n    background-color: #571bbf;\n    border: .25vmin solid black;\n    border-radius: 999em;\n}\n\n.food {\n    background-color: #e60ecc;\n    border: .25vmin solid black;\n    border-radius: 999em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
